// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC1nifwq1IGvZbalRQxyp_BmcpCpSAksOc",
  authDomain: "lempe-d05fb.firebaseapp.com",
  projectId: "lempe-d05fb",
  storageBucket: "lempe-d05fb.appspot.com",
  messagingSenderId: "188356567878",
  appId: "1:188356567878:web:7c15c35bffbac41f50bb47"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);